export default __webpack_public_path__ + "static/media/photo--lg--kara6.c5906d7b.jpg";